export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"

export const changeLanguage = (langCode) => {
    return {
        type: CHANGE_LANGUAGE,
        langCode
    }
}


// WEBPACK FOOTER //
// ./src/features/common/internationalization/InternationalizationActions.js